import { Fragment, ReactElement } from 'react';
import ResearchCivilUnionNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union-non-resident';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCivilUnionNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCivilUnionNonResidentNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchCivilUnionNonResidentNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default ResearchCivilUnionNonResidentNotificationCivilStatusPage;
